<template>
    <Header></Header>
    <main> 
        <Banner :fields="fields['First section']"></Banner>
        
        <SloganTempateLow style="padding-top: 120px; padding-bottom: 140px;" :fields="fields['Second section']"></SloganTempateLow>
        <BlockWrapperAbout>
            <template #left><TextBlock :fields="fields['Third section']"></TextBlock></template>
            <template #right><ImageBlock :fields="fields['Third section']"></ImageBlock></template>
        </BlockWrapperAbout>

        <SloganTempateLow class="left" style="padding-top: 140px" :fields="fields['Fourth section']"></SloganTempateLow>

        <PosotionImgContent
        :content="{
            imagePosition: 'right'
        }"
        ></PosotionImgContent>
        <BlockWrapperAbout class="leftp" style="padding-top: 180px; padding-bottom: 160px;">
            <template #left><ImageBlock :fields="fields['Fifth section']"></ImageBlock></template>
            <template #right><TextBlock :fields="fields['Fifth section']"></TextBlock></template>
        </BlockWrapperAbout>
        <FaqBlock style="padding-top: 140px; padding-bottom: 140px;"></FaqBlock>
    </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import PosotionImgContent from "@/components/Templates/PosotionImgContentRight.vue";
import Banner from "@/components/AboutUs/Banner.vue";
import SloganTempateLow from "@/components/Templates/SloganTempateLow.vue";
import BlockWrapperAbout from "@/components/AboutUs/BlockWrapperAbout.vue";
import ImageBlock from "@/components/AboutUs/ImageBlock.vue";
import TextBlock from "@/components/AboutUs/TextBlock.vue";
import { registerAnimations } from '@/assets/directives/animations';
import axios from "axios";
    export default {
        components: {
            Header,
            Footer,
            FaqBlock,
            PosotionImgContent,
            Banner,
            SloganTempateLow,
            BlockWrapperAbout,
            ImageBlock,
            TextBlock
        },
        computed: {
        fields() {
                return this.$store.state.fields;
            },
        },
        watch: {
        '$route': 'fetchData', // Следим за изменением маршрута
        },
        methods: {
        fetchData() {
            axios.get('/api/data', { params: { url: this.$route.path } })
            .then(response => {
                this.$nextTick(() => {
                    registerAnimations(); // Инициализация анимаций после загрузки данных
                });
            });
        },
        },
        created() {
        this.fetchData(); // Загружаем данные при создании компонента
        },
    }
</script>

<style scoped>

</style>